"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('angular2/core');
var store_1 = require('@ngrx/store');
var actions_1 = require('../actions/actions');
require('./notificationStyles.styl');
require('rxjs/add/operator/do');
var Notifications = (function () {
    function Notifications(store, actions) {
        this.store = store;
        this.actions = actions;
        this.onRemove = new core_1.EventEmitter();
        this.notifications = store.select('notifications');
    }
    Notifications.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.notifications
            .subscribe(function (notifications) {
            _this.autoRemoveNotifications(notifications);
        });
    };
    Notifications.prototype.autoRemoveNotifications = function (notifications) {
        var _this = this;
        if (notifications === void 0) { notifications = []; }
        if (!notifications.length) {
            return;
        }
        setTimeout(function () {
            notifications.forEach(function (notification) {
                _this.removeNotification(notification.id);
                _this.onRemove.next(notification);
            });
        }, this.removeDelay);
    };
    Notifications.prototype.removeNotification = function (id) {
        this.actions.clearNotification(id);
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], Notifications.prototype, "removeDelay", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], Notifications.prototype, "location", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], Notifications.prototype, "onRemove", void 0);
    Notifications = __decorate([
        core_1.Component({
            selector: 'hx-notify',
            styles: ["\n    .notifications {\n      position: fixed;\n      z-index: 10;\n      bottom: 0;\n    }\n    .notification {\n      width: 100%;\n      height: 30px;\n      border-radius: 3px;\n      padding: 15px;\n      text-align: center;\n      color: white;\n      position: relative;\n      color: white;\n      margin-top: 5px;\n    }\n    .alert{\n      background-color: green;\n    }\n    .error{\n      background-color: red;\n    }\n    .message {\n      font-size: 18px;\n    }\n  "],
            template: "\n    <div class=\"notifications\">\n      <div class=\"notification {{ notification.type }}\" *ngFor=\"#notification of notifications | async \">\n        <span class=\"message\">{{ notification.message }}</span>\n      </div>\n    </div>\n  ",
            providers: [actions_1.NotificationActions]
        }), 
        __metadata('design:paramtypes', [store_1.Store, actions_1.NotificationActions])
    ], Notifications);
    return Notifications;
}());
exports.Notifications = Notifications;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/notification.ts
 ** module id = 244
 ** module chunks = 0
 **/